import type { PersonInvolvement } from "../types/involvement.js";

/**
 * Whether an involvement's ending has taken effect. An ending may be set for a
 * later day, and until that day comes the involvement is still part of the
 * case.
 */
export const hasInvolvementEnded = (
  involvement: Pick<PersonInvolvement, "endedAt">,
  now: Date = new Date(),
): boolean => involvement.endedAt !== null && involvement.endedAt <= now;
